import { IGlobalState } from '../../../Root/store/appReducer'

export const getUploadedFileDto = (state: IGlobalState) => state.upload.uploadedFileDto
export const getLastFileUploadFail = (state: IGlobalState) => state.upload.lastFileUploadFail
